export default __webpack_public_path__ + "static/media/63A0EC2E-7B7D-4D11-B828-307F0432A78A.566010d2.jpeg";